import { CommonModule } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ConfigModule } from '@wilson/config';
import { LocalizedDateFormatPipe } from '@wilson/localization';
import { NotificationTimerService } from './notification-timer.service';
import { NotificationsService } from './notifications.service';

@NgModule({
  imports: [CommonModule, ConfigModule, LocalizedDateFormatPipe],
  providers: [
    NotificationsService,
    NotificationTimerService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class NotificationsModule {}
